var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar"},[_c('router-link',{attrs:{"to":{ name: 'checkout' }}},[_c('span',{staticClass:"fa-stack fa-2x has-badge mr-5",attrs:{"data-count":_vm.cartCount()}},[_c('i',{staticClass:"fa fa-circle fa-stack-2x"}),_c('i',{staticClass:"fa fa-shopping-cart fa-stack-1x fa-inverse"})])]),_c('KTQuickUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }